import axios from 'axios';
import server from '../statics/server';

export default {
	data: function() {
		return {
			jobs: []
		}
	},
	mounted: async function() {
		try {
			const response = await axios.post(`${server.addr()}${server.api.COMMON_CODE}`, {
				codeId : "FIL001"
			});
			this.jobs = response.data.list;
		} catch (e) {
			// TODO: error exception
		}
	}
}